<p-toast></p-toast>
<div class="mat-elevation-z8">


    <div class="table-responsive text-center justify-content-center"
        style="font-size:14px; margin-bottom: 20px;text-align: center;vertical-align: center;">

        <p-table [value]="PendingDoctors" #dt1 dataKey="id" [rows]="10" [paginator]="true"
            [showCurrentPageReport]="true" [scrollable]="true" [loading]="this.loading"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            [rowsPerPageOptions]="[10,25,50]" [globalFilterFields]='displayedColumns'>

            <ng-template pTemplate="caption">
                <div class="table-header float-right">
                    <div class="ui-table-globalfilter-container">
                        <input type="text" pInputText size="50" placeholder="Search"
                            (input)="dt1.filterGlobal($event.target.value, 'contains')"
                            style="width:250px;margin-left:75%;">
                    </div>
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th style="width: 130px;" pSortableColumn="">
                        <b>Profile</b>
                    </th>
                    <th style="width: 160px;" pSortableColumn="">
                        <b>Approve</b>
                    </th>
                    <th style="width: 120px;" pSortableColumn="">
                        <b>Decline</b>
                    </th>

                    <th pSortableColumn="status" style="width: 130px;"><b>Status</b></th>
                    <th pSortableColumn="profession_type"><b>Medical Professional Type</b>
                        <p-sortIcon field="profession_type"></p-sortIcon>
                    </th>
                    <th pSortableColumn="name"><b>Name</b>
                        <p-sortIcon field="name"></p-sortIcon>
                    </th>

                    <th pSortableColumn="created_at"><b>Referred On</b>
                        <p-sortIcon field="created_at"></p-sortIcon>
                    </th>
                    <th pSortableColumn="request_sent_date"><b>Request Sent Date</b>
                        <p-sortIcon field="request_sent_date"></p-sortIcon>
                    </th>
                    <th pSortableColumn="doctor_referred_name"><b>Referred By</b>
                        <p-sortIcon field="doctor_referred_name"></p-sortIcon>
                    </th>
                    <th style="width: 240px;" pSortableColumn="Doctoremail"><b>Email</b>
                        <p-sortIcon field="Doctoremail"></p-sortIcon>
                    </th>
                    <th pSortableColumn="country_name"><b>Country</b>
                        <p-sortIcon field="country_name"></p-sortIcon>
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-doctor>
                <tr [pSelectableRow]="doctor">
                    <td style="width: 130px;">
                        <button pButton type="button" *ngIf="doctor.status=='REGISTERED'"
                            class="btn btn-danger btn-sm btn-space" label="View"
                            (click)="getDoctorProfilesData(doctor.user_guid,doctor.profession_type)"
                            [disabled]="posting"></button>
                        <div *ngIf="doctor.status=='PENDING'">NOT REGISTERED </div>
                    </td>
                    <td style="width: 160px;">
                        <button pButton type="button" *ngIf="doctor.status=='REGISTERED'"
                            class="btn btn-danger btn-sm btn-space" label="Approve"
                            (click)="DoAction(2,doctor.user_guid)" [disabled]="posting"></button>
                    </td>
                    <td style="width: 120px;">
                        <button pButton type="button " class="btn btn-danger btn-sm btn-space" label="Decline"
                            (click)="DoAction(3,doctor.user_guid)" [disabled]="posting"></button>

                    </td>
                    <td style="width: 130px;">{{doctor.status}}</td>
                    <td>{{medics[doctor.profession_type]}}</td>
                    <td>{{doctor.name}}</td>
                    <td> {{doctor.created_at | date:'medium'}}</td>
                    <td>
                        <ng-container *ngIf="doctor.request_sent_date!=null">
                            {{doctor.request_sent_date | date:'medium'}}
                        </ng-container>
                        <ng-container *ngIf="doctor.request_sent_date==null">
                            N/A
                        </ng-container>
                    </td>
                    <td>{{doctor.doctor_referred_name == null || doctor.doctor_referred_name =="" ? "N/A" :
                        doctor.doctor_referred_name }}</td>
                    <td style="width: 240px;word-break: break-all;">{{doctor.Doctoremail}}</td>
                    <td>{{doctor.country_name}}</td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>
<p-dialog header="Doctor Profile" *ngIf="DoctorProfileDialogVisible" [resizable]="false" responsive="true"
    [(visible)]="DoctorProfileDialogVisible" (onHide)="CloseReferralView()">
    <div class="ui-g form-group" style="margin-bottom: 5px; width: 800px;"
        *ngIf="response?.success!=null && response?.success==true">
        <div class="card">
            <p-table #dt *ngIf="is_doctor" styleClass="ui-table-cars" id="doctors-grid" expandableRows="true"
                [responsive]="true">
                <ng-template pTemplate="caption" style="color: aliceblue;">
                    <tr>
                        <td style="text-align: justify;">
                            <img [src]="this.getImageUrl(this.defualt_doctor_image,doctorProfile.avatar_url)"
                                height="120px" alt="Dr. Photo">
                            <h4 style="color: white;">
                                {{doctorProfile.doctor_profile.salutation | titlecase}}
                                {{doctorProfile.first_name}}
                                {{doctorProfile.middle_name==null?'':doctorProfile.middle_name}}
                                {{doctorProfile.last_name}},
                                {{doctorProfile.doctor_profile.degree}}
                            </h4>
                            <h4>
                                {{doctorProfile.doctor_profile.speciality.specialty_name}},
                                {{doctorProfile.state_name}},
                                {{doctorProfile.country.country_name}}
                            </h4>
                        </td>
                    </tr>
                </ng-template>

                <ng-template pTemplate="header" let-columns>
                    <tr style="text-align: left;" *ngIf="doctorProfile.doctor_profile.secondary_speciality?.length>0">
                        <p class="header-section">Subspecialities :</p>
                        <ul>
                            <li *ngFor="let sec_specialty of doctorProfile.doctor_profile.secondary_speciality">
                                {{sec_specialty}}
                            </li>
                        </ul>
                    </tr>

                    <tr style="text-align: left;">
                        <p class="header-section"> Resume</p>
                        <div style="margin-left: 40px;" *ngIf="resume_url!=null">
                            <button pButton type="button" class="btn btn-danger btn-sm btn-space"
                                (click)="view_resume()" label="View Resume"></button>
                        </div>
                        <div style="margin-left: 40px;" *ngIf="resume_url==null">
                            No Resume has been uploaded.
                        </div>
                    </tr>
                    <tr style="text-align: left;" *ngIf="langs?.length>0">
                        <p class="header-section">Languages Spoken</p>
                        <ul>
                            <li style="white-space: pre-line;" *ngFor="let l of langs">
                                {{l.language_name +" ("+l.english_name+")"}}
                            </li>
                        </ul>

                    </tr>
                    <tr style="text-align: left;" *ngIf="this.doctorProfile.doctor_profile.description?.length>0">
                        <p class="header-section">Bio</p>
                        <div style="margin-left: 40px;">
                            <p style="white-space: pre-line;">{{doctorProfile.doctor_profile.description}}</p>
                        </div>
                    </tr>
                    <tr style="text-align: left;" *ngIf="this.is_uk_country">
                        <p class="header-section">GMC Number</p>
                        {{doctorProfile.doctor_profile.gmc_reg_no}}

                    </tr>
                    <tr style="text-align: left;" *ngIf="doctorProfile.doctor_profile.education?.residency?.length>0">
                        <p class="header-section">Residency</p>
                        <ul>
                            <li style="white-space: pre-line;"
                                *ngFor="let residency of doctorProfile.doctor_profile.education?.residency">
                                {{residency.name}}
                            </li>
                        </ul>

                    </tr>

                    <tr style="text-align: left;"
                        *ngIf="doctorProfile.doctor_profile.education?.medical_school?.length>0">
                        <p class="header-section">Medical School </p>
                        <ul>
                            <li *ngFor="let edu of doctorProfile.doctor_profile.education?.medical_school">
                                <span style="white-space: pre-line;">{{edu.name}}</span> : {{edu.year}}
                            </li>
                        </ul>
                    </tr>

                    <tr style="text-align: left;" *ngIf="doctorProfile.doctor_profile.education?.fellowship?.length>0">
                        <p class="header-section">Fellowship</p>
                        <ul>
                            <li *ngFor="let edu of doctorProfile.doctor_profile.education?.fellowship">
                                <span style="white-space: pre-line;">{{edu.name}}</span> : {{edu.year}}
                            </li>
                        </ul>
                    </tr>

                    <tr style="text-align: left;" *ngIf="doctorProfile.doctor_profile.board_certification?.length>0">
                        <p class="header-section"> Board Certifications</p>
                        <ul>
                            <li style="white-space: pre-line;"
                                *ngFor="let board of doctorProfile.doctor_profile.board_certification">
                                {{board}}
                            </li>
                        </ul>
                    </tr>
                    <div *ngIf="doctorProfile.country.country_name==='United States'; else not_national_license">
                        <tr style="text-align: left;"
                            *ngIf="doctorProfile.doctor_profile.states_to_practice?.length>0 ">
                            <p class="header-section">States to Practice</p>
                            <ul>
                                <li *ngFor="let edu of doctorProfile.doctor_profile.states_to_practice">
                                    <span style="white-space: pre-line;">{{edu.state_name}}</span> : {{edu.license_no}}
                                </li>
                            </ul>
                        </tr>
                    </div>
                    <ng-template #not_national_license>
                        <tr style="text-align: left;"
                            *ngIf="doctorProfile.doctor_profile.states_to_practice?.length>0 ">
                            <p class="header-section">License Number</p>
                            <ul>
                                <li *ngFor="let edu of doctorProfile.doctor_profile.states_to_practice">
                                    {{edu.license_no}}
                                </li>
                            </ul>
                        </tr>
                    </ng-template>
                    <tr style="text-align: left;"
                        *ngIf="doctorProfile.doctor_profile.honors_awards_recognition?.length>0">
                        <p class="header-section"> Honors, Awards & Recognitions</p>
                        <ul>
                            <li style="white-space: pre-line;"
                                *ngFor="let honors of doctorProfile.doctor_profile.honors_awards_recognition">
                                {{honors}}
                            </li>
                        </ul>
                    </tr>
                    <tr style="text-align: left;" *ngIf="doctorProfile.doctor_profile.publications?.length>0">
                        <p class="header-section"> Publications</p>
                        <ul>
                            <li style="white-space: pre-line;"
                                *ngFor="let publication of doctorProfile.doctor_profile.publications">
                                {{publication}}
                            </li>

                        </ul>
                    </tr>
                    <tr style="text-align: left;"
                        *ngIf="this.is_uk_country && doctorProfile.doctor_profile.gmc_reg_no?.length>0">
                        <p class="header-section">Certificates</p>
                        <ul>
                            <li *ngFor="let certificate of certs">
                                <a href="#"
                                    (click)="downloadBase64PDF(certificate.document_url, certificate.document_name); $event.preventDefault()"
                                    style="word-break: break-word">
                                    {{ certificate.document_name }}
                                </a>
                            </li>
                        </ul>


                    </tr>

                </ng-template>
            </p-table>
            <p-table #dt *ngIf="!is_doctor" styleClass="ui-table-cars" id="doctors-grid" expandableRows="true"
                [responsive]="true">
                <ng-template pTemplate="caption" style="color: aliceblue;">
                    <tr>
                        <td style="text-align: justify;">
                            <img [src]="this.getImageUrl(this.defualt_doctor_image,otherMedicalProfile.avatar_url)"
                                height="120px" alt="Dr. Photo">
                            <h4 style="color: white;">
                                {{otherMedicalProfile.first_name}}
                                {{otherMedicalProfile.middle_name==null?'':otherMedicalProfile.middle_name}}
                                {{otherMedicalProfile.last_name}}

                            </h4>
                            <h4>
                                {{otherMedicalProfile.state_name}}, {{otherMedicalProfile.country.country_name}}</h4>
                        </td>
                    </tr>
                </ng-template>

                <ng-template pTemplate="header" let-columns>


                    <tr style="text-align: left;">
                        <p class="header-section"> Resume</p>
                        <div style="margin-left: 40px;" *ngIf="resume_url!=null">
                            <button pButton type="button" class="btn btn-danger btn-sm btn-space"
                                (click)="view_resume()" label="View Resume"></button>
                        </div>
                        <div style="margin-left: 40px;" *ngIf="resume_url==null">
                            No Resume has been uploaded.
                        </div>
                    </tr>

                    <tr style="text-align: left;" *ngIf="langs?.length>0">
                        <p class="header-section">Languages Spoken</p>
                        <ul>
                            <li style="white-space: pre-line;" *ngFor="let l of langs">
                                {{l.language_name +" ("+l.english_name+")"}}
                            </li>
                        </ul>

                    </tr>

                    <!--Other medical Profile-->
                    <tr style="text-align: left;"
                        *ngIf="otherMedicalProfile.other_medical_profile.certifications?.length>0">
                        <p class="header-section"> Certifications</p>
                        <ul>
                            <li style="white-space: pre-line;"
                                *ngFor="let board of otherMedicalProfile.other_medical_profile.certifications">
                                {{board}}
                            </li>
                        </ul>
                    </tr>
                    <tr style="text-align: left;" *ngIf="otherMedicalProfile.other_medical_profile.education?.length>0">
                        <p class="header-section">Medical School </p>
                        <ul>
                            <li *ngFor="let edu of otherMedicalProfile.other_medical_profile.education">
                                <span style="white-space: pre-line;">{{edu.name}}</span> : {{edu.year}}
                            </li>
                        </ul>
                    </tr>
                    <tr style="text-align: left;"
                        *ngIf="otherMedicalProfile.other_medical_profile.affiliated_hospitals?.length>0">
                        <p class="header-section"> Affiliated Hospitals</p>
                        <ul>
                            <li style="white-space: pre-line;"
                                *ngFor="let board of otherMedicalProfile.other_medical_profile.affiliated_hospitals">
                                {{board}}
                            </li>
                        </ul>
                    </tr>
                    <tr style="text-align: left;" *ngIf="otherMedicalProfile.other_medical_profile.license_number">
                        <p class="header-section"> License No.</p>
                        {{otherMedicalProfile.other_medical_profile.license_number}}
                    </tr>
                    <tr style="text-align: left;" *ngIf="otherMedicalProfile.other_medical_profile.primary_occupation">
                        <p class="header-section"> Primary Occupation</p>
                        {{otherMedicalProfile.other_medical_profile.primary_occupation}}
                    </tr>
                    <tr style="text-align: left;"
                        *ngIf="otherMedicalProfile.other_medical_profile.secondary_occupation">
                        <p class="header-section"> Secondary Occupation</p>
                        {{otherMedicalProfile.other_medical_profile.secondary_occupation}}
                    </tr>
                    <tr style="text-align: left;" *ngIf="otherMedicalProfile.other_medical_profile.years_of_experience">
                        <p class="header-section"> Years of Experience</p>
                        {{otherMedicalProfile.other_medical_profile.years_of_experience}}
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
    <div class="row container justify-content-center text-center alert alert-danger"
        *ngIf="response?.success!=null && response?.success==false">
        <p *ngIf="response?.error!=null">{{response?.error.message}}</p>
        <div *ngIf="serverError?.error!=null && serverError?.statusCode!=500">
            <p *ngFor="let message of serverError?.message">{{message}}</p>
        </div>
        <div *ngIf="serverError?.error!=null && serverError?.statusCode==500">
            <p>{{serverError?.message}}</p>
        </div>

    </div>
    <p *ngIf="posting && DoctorProfileDialogVisible">Fetching doctor profile....</p>
    <p-progressSpinner [style]="{width: '50px', height: '50px'}" *ngIf="posting && DoctorProfileDialogVisible"
        strokeWidth="6"></p-progressSpinner>
    <p-footer>
        <button pButton type="button" class="btn btn-danger btn-sm btn-space" (click)="CloseReferralView()"
            label="Close"></button>
    </p-footer>

</p-dialog>

<p-dialog [(visible)]="displayViewResume" optionLabel="label" [contentStyle]="{height:'100%'}" [style]="{width: '98vw'}"
    (onHide)="close_resume()" header="Resume" [baseZIndex]="10000">
    <ngx-doc-viewer [url]="resume_url" viewer="google" style="width:100%;height:100vh;"></ngx-doc-viewer>
    <p-footer>
        <button pButton type="button" label="Close" (click)="close_resume()"
            class="p-button btn btn-primary btn-default"></button>
    </p-footer>
</p-dialog>
<!-- 
<div class="row container justify-content-center text-center alert alert-danger"
    *ngIf="response.success!=null && response.success==false">
    <p *ngIf="response.error!=null">{{response.error.message}}</p>
    <div *ngIf="serverError?.error!=null && serverError?.statusCode!=500">
        <p *ngFor="let message of serverError?.message">{{message}}</p>
    </div>
    <div *ngIf="serverError?.error!=null && serverError?.statusCode==500">
        <p>{{serverError?.message}}</p>
    </div>

</div> -->

<div class="row container justify-content-center text-center alert alert-danger"
    *ngIf="this.table_response?.success!=null && this.table_response?.success==false">
    <p *ngIf="this.table_response?.error!=null">{{this.table_response?.error?.message}}</p>
    <div *ngIf="this.table_serverError?.error!=null && this.table_serverError?.statusCode!=500">
        <p *ngFor="let message of this.table_serverError?.message">{{message}}</p>
    </div>
    <div *ngIf="this.table_serverError?.error!=null && this.table_serverError?.statusCode==500">
        <p>{{this.table_serverError?.message}}</p>
    </div>

</div>
<p-progressSpinner [style]="{width: '50px', height: '50px'}" *ngIf="posting" strokeWidth="6"></p-progressSpinner>